import React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

// Shaped like the summary line and the first rows of the preview table, so the wait reads as the
// table arriving rather than as a screen that has stopped.
const PLACEHOLDER_ROW_COUNT = 8;

export default function LcvOrderPreviewSkeleton() {
     return (
          <Box sx={{ mt: 1 }}>
               <Skeleton variant="text" width="55%" sx={{ mb: 2 }} />

               {Array.from({ length: PLACEHOLDER_ROW_COUNT }).map((unused, index) => (
                    <Box
                         key={index}
                         sx={{
                              display: "flex",
                              gap: 2,
                              py: 1.5,
                              borderBottom: "1px solid",
                              borderColor: "divider",
                         }}
                    >
                         <Skeleton variant="text" width="8%" />
                         <Skeleton variant="text" width="16%" />
                         <Skeleton variant="text" width="20%" />
                         <Skeleton variant="text" width="14%" />
                         <Skeleton variant="text" width="22%" />
                         <Skeleton variant="text" width="12%" />
                    </Box>
               ))}
          </Box>
     );
}
